import { Container } from "@mui/material"
import { AyudantiasAcademicas } from "../../components/AyudantiasAcad/AyudantiasEstudiante"




interface Props{
    
}
export const AyudantiasAcadPage: React.FC<Props> = () => {
    
    return (
        <Container maxWidth="xl" sx={{ padding: "20px"}}>
            <AyudantiasAcademicas />
        </Container>
        
    )

}